import { FC, useContext } from 'react';
import { Table } from 'antd';

import { SectionQuotation } from '../../../../../../../shared';
import { StepTwoFormContext } from '../../../../../StepTwo/contexts/StepTwoForm';
import { formattedPrice } from '../../../../../../../../../../../shared/utils';

const MOCK_TABLE_COLUMNS_HEADER = [
  {
    title: 'Accesorio',
    dataIndex: 'accessoryDescription',
  },
  {
    title: 'Precio',
    dataIndex: 'price',
    render: (text: string) => <span>{`$${formattedPrice(text)}`}</span>,
  },
];

interface AccessoriesProps {
  tabKey: number;
}

export const Accessories: FC<AccessoriesProps> = ({ tabKey }) => {
  const { accessoryTable } = useContext(StepTwoFormContext);

  return (
    <SectionQuotation level='h3' title='Accesorios' hasCard={false}>
      <Table
        bordered
        className='person-table mb-1'
        columns={MOCK_TABLE_COLUMNS_HEADER}
        dataSource={accessoryTable[tabKey]}
        pagination={false}
        scroll={{ x: 'auto' }}
      />
    </SectionQuotation>
  );
};
